// Helper to build a BreadcrumbList JSON-LD script entry for TanStack route head()
export const SITE_URL = "https://elvion-group.nl";

export type Crumb = { name: string; path: string };

export function breadcrumbJsonLd(crumbs: Crumb[]) {
  const items = [{ name: "Home", path: "/" }, ...crumbs];
  return {
    type: "application/ld+json" as const,
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.name,
        item: `${SITE_URL}${c.path === "/" ? "" : c.path}`.replace(/\/$/, "") || SITE_URL,
      })),
    }),
  };
}
